import { stopViewStreamRequest, viewStreamIceCandidate, viewStreamConnectionStateChange, viewStreamRequest, } from "./actions";
import { trackMuteUpdateEvent } from "../actions";
/**
 * Tests if request should be handled by saga
 * @param tasks - Object's keys are stream IDs
 */
export function stopViewStreamRequestPattern(tasks) {
    return (action) => action.type === stopViewStreamRequest.toString() &&
        action.payload.streamId in tasks;
}
/**
 * Tests if ice state change of rtc peer connection should concern this saga
 * @param tasks
 */
export function viewStreamConnectionStateChangePattern(tasks) {
    return (action) => action.type === viewStreamConnectionStateChange.toString() &&
        action.payload.streamId in tasks;
}
export function viewStreamRequestPattern(conferenceId) {
    return (action) => action.type === viewStreamRequest.toString() &&
        action.payload.conferenceId === conferenceId;
}
export function viewStreamIceCandidatePattern(streamId) {
    return (action) => action.type === viewStreamIceCandidate.toString() &&
        action.payload.streamId === streamId;
}
export function trackMuteUpdatePattern(conferenceId) {
    return (action) => action.type === trackMuteUpdateEvent.toString() &&
        action.payload.conferenceId === conferenceId;
}
//# sourceMappingURL=patterns.js.map